var map = {
	"./Minus.svg": 84493,
	"./Plus.svg": 69998,
	"./avatar_five.svg": 91199,
	"./avatar_four.svg": 33243,
	"./avatar_one.svg": 92436,
	"./avatar_six.svg": 61572,
	"./avatar_three.svg": 7468,
	"./avatar_two.svg": 51463,
	"./case_reports.svg": 6384,
	"./clients.svg": 92153,
	"./down-arrow.svg": 29197,
	"./edit.svg": 23737,
	"./empty_case_report.svg": 90402,
	"./empty_client.svg": 59545,
	"./empty_summary_report.svg": 3332,
	"./follow_ups.svg": 2274,
	"./left_arrow_black.svg": 33706,
	"./left_arrow_long_blue.svg": 57275,
	"./right_arrow_black.svg": 97396,
	"./right_arrow_grey.svg": 17550,
	"./sessions.svg": 50399,
	"./summary.svg": 59070,
	"./up-arrow.svg": 93025
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56775;